import { useExperiment } from 'utils/experiments'

export type StarterOrPioneerVariant = 'pioneer' | 'starter' | 'growth'

export const useIsPioneerStarterOrGrowth = (): StarterOrPioneerVariant => {
  const location = window.location // eslint-disable-line no-restricted-properties
  const isGrowth = location.search.includes('campaigns=true')
  const starterOrPioneerVariant = useExperiment('starter_or_pioneer') || 'pioneer'

  if (isGrowth) return 'growth'

  return starterOrPioneerVariant as StarterOrPioneerVariant
}
